import React from 'react';
import { CriteriaConfig, LogFilterType, TimeDetails } from '@src/dtos/search-criteria.dto';
import { Input, Select, Tooltip } from 'antd';
import { TimeCriteria } from '../../features/reports-and-logs/logs/search/time-criteria';
import MultiSelect from '../multi-select/multi-select';
import './criteria-list.scss';
import DropArrow from '@svg/chevron-down_20.svg?react';

interface CriteriaListProps<T> {
    criteriaConfig: CriteriaConfig<T>[];
    searchCriteria: T;
    changeSearchCriteria: (searchCriteria: T, accessor: keyof T) => void;
    validationErrors: Map<string, string>;
}

export const CriteriaList = <T, >({ criteriaConfig, searchCriteria, changeSearchCriteria, validationErrors }: CriteriaListProps<T>) => {

    const onSelectCriteria = (value: any, accessor: keyof T) => {
        changeSearchCriteria({ ...searchCriteria,
            [accessor]: typeof value === 'string' ? value.trim() : value }, accessor);
    };

    const onSetTime = (time: TimeDetails) => {
        changeSearchCriteria({...searchCriteria,
            timeDetails: time
        },'timeDetails' as keyof T);
    };

    const renderCriteria = (criteria: CriteriaConfig<T>) => {
        
        const { accessor, disabled } = criteria;
        const value = searchCriteria[accessor] as any;
        const options = criteria.options;
        const errors = validationErrors.get(accessor);
        const status = errors ? 'error' : '';
        
        switch (criteria.type) {
            case LogFilterType.INPUT:
                return <Tooltip open={!!errors} title={errors} placement={'bottom'}>
                    <Input placeholder={criteria.defaultValue} value={value}
                        onChange={(e) => onSelectCriteria(e.target.value, accessor)}
                        key={accessor} status={status} disabled={disabled}/>
                </Tooltip>;
            case LogFilterType.INPUT_NUMBER:
                return <Tooltip open={!!errors} title={errors} placement={'bottom'}>
                    <Input placeholder={criteria.defaultValue} value={value}
                        onChange={(e) => onSelectCriteria(e.target.value.replace(/\D/g, ''), accessor)}
                        key={accessor} status={status} />
                </Tooltip>;
            case LogFilterType.DROP_DOWN:
                return <Select value={value} getPopupContainer={(triggerNode) => triggerNode.parentElement} popupClassName={'dropdown-custom'}
                    key={accessor} options={options} onSelect={(value) => onSelectCriteria(value, accessor)} suffixIcon={<DropArrow />} disabled={disabled}/>;
            case LogFilterType.MULTISELECT: {
                return <MultiSelect showSearch={criteria.showSearch}
                                    showAllOption={criteria.showAllOption}
                                    options={options || []}
                                    selectedList={value}
                                    overlayClassName={accessor}
                                    onSelectionChange={(values) => onSelectCriteria(values, accessor)} 
                                    disabled={disabled}
                                    />;
            }
            case LogFilterType.TIME:
                return <TimeCriteria options={options || []} setTime={onSetTime} value={value} allowedDaysAgo={criteria.allowedDaysAgo} disabled={disabled}/>;
        }
    };

    return <div className="filters flex">
        {criteriaConfig.map(criteria => <div key={`${criteria.accessor}`} style={{ width: criteria.width }} className={'inner-filter'}>
            <div key={`${criteria.accessor} header`} className={'filter-label'}>{criteria.header}</div>
            <div key={`${criteria.accessor} filter`} className={`${criteria.accessor} filter`} data-testid={`${criteria.accessor} filter`}>{renderCriteria(criteria)}</div>
        </div>)}
    </div>;

};